import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col col-12 pt-4" }
const _hoisted_2 = { class: "text-center fw-bold pitch-overarching-header display-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col col-12 offset-lg-1 col-lg-10 pb-2 pitch-content-container" }
const _hoisted_5 = { class: "h1" }
const _hoisted_6 = { class: "h3" }
const _hoisted_7 = { class: "pitch-font" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.getOverallClass)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString($props.title), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.pitches, (pitch) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col col-12 col-lg-4 text-center",
        key: pitch.title
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(pitch.title), 1),
            _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "bolder-hr d-none d-lg-block" }, null, -1)),
            _createElementVNode("h4", _hoisted_6, _toDisplayString(pitch.summary), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(pitch.details), 1)
          ])
        ])
      ]))
    }), 128))
  ], 2))
}